import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import cx from 'classnames';
import { Map } from 'immutable';

import Quote from 'models/quote';
import { Location } from 'models/locations';

import * as AppContext from 'lib/app-context';

import AutoExtendTooltip from 'components/checkout/parking-details/time-picker/auto-extend-tooltip';

const propTypes = {
  directAffiliateTraffic: PropTypes.bool.isRequired,
  shouldRender: PropTypes.bool,
  bookExtendedTimes: PropTypes.bool.isRequired,
  timezone: PropTypes.string.isRequired,
  appContext: PropTypes.string.isRequired,
  showAutoExtendTooltip: PropTypes.bool.isRequired,
  position: PropTypes.string,
  selectedQuote: PropTypes.instanceOf(Quote),
  selectedLocation: PropTypes.instanceOf(Location),
  sellers: PropTypes.instanceOf(Map),
  renderContext: PropTypes.arrayOf(PropTypes.string),
  toggleBookExtendedTimes: PropTypes.func.isRequired,
  toggleAutoExtendTooltip: PropTypes.func.isRequired,
  hideAutoExtendTooltip: PropTypes.func.isRequired,
};

const defaultProps = {
  selectedQuote: new Quote(),
  selectedLocation: new Location(),
  sellers: Map(),
  position: 'bottom',
  renderContext: [AppContext.DESKTOP, AppContext.MOBILE, AppContext.TABLET],
  shouldRender: false,
};

const AutoExtendLabel = ({
  shouldRender,
  position,
  bookExtendedTimes,
  sellers,
  timezone,
  selectedQuote,
  selectedLocation,
  directAffiliateTraffic,
  toggleAutoExtendTooltip,
  toggleBookExtendedTimes,
  renderContext,
  appContext,
  showAutoExtendTooltip,
  hideAutoExtendTooltip,
}) => {
  if (!shouldRender || !renderContext.includes(appContext)) { return null; }

  const positionClassName = cx({
    'auto-extend-label-top': position === 'top',
  });

  return (
    <div className={`${positionClassName} auto-extend-label background-color-blue-light-grey background-color-hover-blue-light-grey-darken text-color-dark-slate text-size-12 padding-vertical-5 padding-horizontal-10 text-wweight-book border-radius-rounded clickable`} onClick={toggleAutoExtendTooltip}>
      <FormattedMessage
        id="checkout.extend-label"
        defaultMessage="More Time, Same Price"
      />
      <AutoExtendTooltip
        directAffiliateTraffic={directAffiliateTraffic}
        bookExtendedTimes={bookExtendedTimes}
        timezone={timezone}
        selectedQuote={selectedQuote}
        selectedLocation={selectedLocation}
        sellers={sellers}
        toggleBookExtendedTimes={toggleBookExtendedTimes}
        showAutoExtendTooltip={showAutoExtendTooltip}
        hideAutoExtendTooltip={hideAutoExtendTooltip}
      />
    </div>
  );
};

AutoExtendLabel.propTypes = propTypes;
AutoExtendLabel.defaultProps = defaultProps;
export default AutoExtendLabel;
